"use client";

import { useState } from "react";
import { Check, Copy } from "lucide-react";

export function TemplateCopyButton({
  markdown,
  label,
  copiedLabel,
  helperText,
}: {
  markdown: string;
  label: string;
  copiedLabel: string;
  helperText: string;
}) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(markdown);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      /* clipboard blocked; the template is on the page regardless */
    }
  };

  return (
    <div className="mt-6 flex flex-wrap items-center gap-3 rounded-xl border border-border bg-muted/30 px-4 py-3">
      <button
        onClick={copy}
        data-testid="copy-template"
        aria-live="polite"
        className="flex min-h-[40px] items-center gap-2 rounded-lg bg-accent px-4 text-sm font-medium text-accent-foreground hover:opacity-90"
      >
        {copied ? <Check className="h-4 w-4" /> : <Copy className="h-3.5 w-3.5" />}
        {copied ? copiedLabel : label}
      </button>
      <span className="text-xs text-muted-foreground">{helperText}</span>
    </div>
  );
}
